import { UserRole } from "authentication/userrole";
import React from "react";
import { Outlet } from "react-router";
import { useAuth } from "shared/provider/auth_provider";

interface AccessControlProps {
  allowedRoles?: Array<UserRole>;
  fallback?: React.JSX.Element; // optional fallback element (e.g. 403 page)
  children?: React.ReactNode;
}

const AccessControlGuard: React.FC<AccessControlProps> = (props) => {
  const { authData } = useAuth();

  let isAllowed = true;

  if (
    isAllowed &&
    props.allowedRoles &&
    authData.roles.every(
      (role) => !props.allowedRoles.includes(role as UserRole),
    )
  ) {
    isAllowed = false;
  }

  if (!isAllowed) {
    return props.fallback || <></>;
  }

  return <>{props.children ? props.children : <Outlet />}</>;
};

export default AccessControlGuard;
